// extracted by mini-css-extract-plugin
module.exports = {"textWrap":"Notice_textWrap__d6myR","noticeHeader":"Notice_noticeHeader__JaDpD","noticeInput":"Notice_noticeInput__1JtiB"};